import _classCallCheck from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Vector3d } from "./Vector3d";
export var Vector = /*#__PURE__*/function (_Vector3d) {
  _inherits(Vector, _Vector3d);
  function Vector(xOrCoords, y) {
    _classCallCheck(this, Vector);
    return _possibleConstructorReturn(this, _getPrototypeOf(Vector).call(this, xOrCoords, y, 0));
  }
  _createClass(Vector, null, [{
    key: "clone",
    value: function clone(source) {
      return Vector.create(source.x, source.y);
    }
  }, {
    key: "create",
    value: function create(x, y) {
      return new Vector(x, y);
    }
  }, {
    key: "origin",
    get: function get() {
      return Vector.create(0, 0);
    }
  }]);
  return Vector;
}(Vector3d);